import { AgencyInformationBlock } from '@urbanx/agx.support.client'
import { AgxColumn, AgxRow, AgxTypography } from '@urbanx/agx.ui-components2'
import PoisonQueueInformationTidbit from './PoisonQueueInformationTidbit'
import PoisonQueuePhotoDisplay from './PoisonQueuePhotoDisplay'

const PoisonQueueAgencyInformation = ({
  agencyInformation,
}: {
  agencyInformation?: AgencyInformationBlock
}) => {
  const { name, tradingName, logoUri, integrations, agencyMembers, teams } =
    agencyInformation || {}

  if (!agencyInformation) return null

  return (
    <AgxColumn gap="spacing-md" fill>
      <AgxTypography id="agency-information" type="heading" size="small">
        Agency Information
      </AgxTypography>

      <AgxRow gap="spacing-lg" fill>
        <PoisonQueuePhotoDisplay photoUri={logoUri} />

        <AgxColumn gap="spacing-2xl" fill>
          <AgxColumn gap="spacing-md" fill>
            <PoisonQueueInformationTidbit label={'Name'} value={name} />

            <PoisonQueueInformationTidbit
              label={'Trading Name'}
              value={tradingName}
            />

            <PoisonQueueInformationTidbit
              label={'REA Agency Code'}
              value={integrations?.reaAgencyCode}
            />

            <PoisonQueueInformationTidbit
              label={'Domain Agency Code'}
              value={integrations?.domainAgencyCode}
            />

            <PoisonQueueInformationTidbit
              label={'Campaign Flow Tenant Id'}
              value={integrations?.campaignFlowTenantId}
            />

            <PoisonQueueInformationTidbit
              label={'Rex Brand Account Id'}
              value={integrations?.rexBrandAccountId}
            />

            <PoisonQueueInformationTidbit
              label={'Agency Members'}
              value={agencyMembers}
            />
          </AgxColumn>

          <AgxColumn gap="spacing-2xl" fill>
            {teams && teams.length > 0 && (
              <>
                <AgxTypography
                  id={'agencyTeams'}
                  type={'title'}
                  size={'medium'}
                >
                  Agency Teams
                </AgxTypography>
                {teams.map((team, idx) => {
                  return (
                    <AgxRow gap="spacing-lg" fill key={idx}>
                      <PoisonQueuePhotoDisplay photoUri={team.teamLogoUri} />
                      <AgxColumn gap="spacing-md" fill>
                        <PoisonQueueInformationTidbit
                          label={'Team Name'}
                          value={team.name}
                        />
                        <PoisonQueueInformationTidbit
                          label={'Team Members'}
                          value={team.teamMembers}
                        />
                      </AgxColumn>
                    </AgxRow>
                  )
                })}
              </>
            )}
          </AgxColumn>
        </AgxColumn>
      </AgxRow>
    </AgxColumn>
  )
}

export default PoisonQueueAgencyInformation
